import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class EmailDomainWhitelistManagementService {
	private urlPath = '';
	constructor(private httpClient: HttpClient) {
		this.urlPath = `${environment.apiUrl}admin/email-domain-whitelist-management`;
	}
	getAll(): Observable<any> {
		return this.httpClient.get<any>(`${this.urlPath}`);
	}
	get(id: string): Observable<any> {
		return this.httpClient.get<any>(`${this.urlPath}/${id}`);
	}
	create(model: any): Observable<any> {
		return this.httpClient.post<any>(`${this.urlPath}`, model);
	}
	update(id: string, model: any): Observable<any> {
		return this.httpClient.put<any>(`${this.urlPath}/${id}`, model);
	}
	remove(id: string): Observable<any> {
		return this.httpClient.delete<any>(`${this.urlPath}/${id}`);
	}
	setActiveStatus(ids: string[], isActive: boolean): Observable<any> {
		return this.httpClient.post<any>(`${this.urlPath}/set-active-status`, { ids, isActive });
	}
	getByClientId(clientId: string): Observable<any> {
		return this.httpClient.get<any>(`${this.urlPath}/by-client/${clientId}`);
	}
	getDefaultEmailSettings(): Observable<any> {
		return this.httpClient.get<any>(`${this.urlPath}/email-default-settings`);
	}
	getDefaultWhitelist(): Observable<any> {
		return this.httpClient.get<any>(`${this.urlPath}/default`);
	}
}
